import { apiClient } from '@src/services/http-common'
import { useMutation } from '@tanstack/react-query'

interface SubmitContactDTO {
  name: string
  email: string
  message: string
}

const submitContact = async (formData: SubmitContactDTO) => {
  const response = await apiClient.post('/Contact', formData)
  return response.data as SubmitContactDTO
}

export const useSubmitContact = () => {
  const { mutateAsync, isPending, reset } = useMutation({
    mutationFn: submitContact,
  })

  return [mutateAsync, isPending, reset] as const
}
